const ua = {
  banner: {
    title: 'Худни розумно',
    subtitle: 'Натуральний спалювач жиру для досягнення результату',
    cta: 'Обрати упаковку',
    slide1: 'Видимий результат за 10 днів',
    slide2: 'Досить колоти Оземпік',
    slide3: 'Більше енергії — менше голоду',
  },
  about: {
    title: 'Як це працює',
    description: 'Наші капсули прискорюють обмін речовин та зменшують апетит без побічних ефектів.',
    feature1: 'Натуральні інгредієнти',
    feature2: 'Швидкий результат',
    feature3: 'Безпечно та сертифіковано',
  },
  buy: {
    title: 'Оберіть упаковку',
    pack1: '10 капсул',
    pack2: '30 капсул',
    pack3: '100 капсул',
    cta: 'Купити',
  },
  faq: {
    title: 'Питання та відповіді',
    q1: 'Наскільки безпечний препарат?',
    a1: 'Цей медичний препарат протестовано та він є повністю безпечним при дотриманні дозування та протипоказань.',
    q2: 'Як часто слід приймати препарат?',
    a2: 'Приймати 1 раз на день, строго натщесерце, за годину до сніданку. Не рекомендується приймати у другій половині дня, щоб уникнути проблем зі сном.',
    q3: 'Хто виробник препарату?',
    a3: 'Виробником та постачальником є компанія "Lannet", США.',
    q4: 'Де ознайомитись з офіційною інструкцією?',
    a4: 'Ви можете ознайомитись з інструкцією на сайті виробника.',
    q5: 'Які перші відчуття після прийому капсули?',
    a5: 'Через 20–30 хвилин ви відчуєте приплив енергії та зниження апетиту на тривалий час.',
    q6: 'Як здійснюється оплата та доставка?',
    a6: 'Оплатити можна банківським переказом або післяплатою при отриманні на пошті.',
    q7: 'Чи виникне залежність від препарату?',
    a7: 'При правильному вживанні згідно з інструкцією виробника, залежність не виникає.',
  },
  contact: {
    title: 'Замовлення / Звʼязок',
    name: 'Ваше імʼя',
    email: 'Ваш e-mail',
    phone: 'Ваш телефон',
    message: 'Повідомлення або деталі замовлення',
    send: 'Надіслати',
    success: '✅ Заявку надіслано!',
    error: '❌ Помилка відправки. Спробуйте пізніше.',
    notify: 'Нове замовлення з сайту Body Harmony',
  },
  
}

export default ua
